<template>
  <span @click="toggleTooltip()">
    <button type="button" class="btn btn-warning" @click="triggerAction()">
      <i v-if="isRunning" class="fas fa-circle-notch fa-spin"></i>
      <i v-else class="fas fa-play"></i>
      {{ buttonLabel }}
    </button>
    <div v-if="showTooltip && tooltips.length" class="tooltip bs-tooltip-bottom show">
      <div class="arrow"></div>
      <div class="tooltip-inner">
        <div v-for="(tt, index) in tooltips" :key="index">{{ tt }}</div>
      </div>
    </div>
  </span>
</template>

<script>
import ResettableTimeout from 'CORE/utils/resettable-timeout'
import LangFilters from 'CORE/mixins/langFilters'
import _ from 'lodash'

export default {
    name: 'TriggerDetail',
    mixins: [
        LangFilters,
    ],
    props: {
        value: { default: null, type: Object },
        id: { default: _ => '', type: String },
        tooltip: { default: _ => null, type: String },
        meta: { default: _ => {}, type: Object },
    },
    data() {
        return {
            showTooltip: false,
            idleTimeout: new ResettableTimeout(function() {
                this.showTooltip = false
            }.bind(this), 10 * 1000), // 10s
            isRunning: false,
        }
    },
    computed: {
        tooltips() {
            const tooltips = []
            if (_.get(this.value, '_meta.translated')) {
                tooltips.push('Ma ruzne hodnoty v jinych jazycich')
            }
            if (_.isString(this.tooltip)) {
                tooltips.push(this.tooltip)
            }
            return tooltips
        },
        propertyType() {
            return this.$store.getters.propertyTypeByKey(this.id) || {}
        },
        buttonLabel() {
            const label = _.get(this, 'propertyType.name', false)
            if (label) return label
            return 'Spustit akci'
        },
    },
    mounted() {
        this.idleTimeout.start()
    },
    destroyed() {
        this.idleTimeout.clear()
    },
    methods: {
        toggleTooltip() {
            this.showTooltip = !this.showTooltip
            if (this.showTooltip) {
                this.idleTimeout.start()
                this.idleTimeout.reset()
            }
        },
        async triggerAction() {
            try {
                this.isRunning = true
                const projectId = _.get(this, 'meta.projectId', null)
                await this.$store.dispatch('fireTrigger', [projectId, _.get(this, 'propertyType.id')])
                this.flash('Akce proběhla v pořádku', 'success', {
                    timeout: 3000,
                })
            } catch (e) {
                console.warn(e)
                this.flash(`Při vykonávání akce nastala chyba ${e}`, 'error', {
                    timeout: 3000,
                })
            } finally {
                this.isRunning = false
            }
        },
    },
}
</script>

<style>
    .detail-body {
        margin: 5px;
        flex-grow: 1;
    }
    .has-tooltip {
        cursor: help;
    }
    .detail-body > div:first-child {
        font-size: 15px;
        color: gray;
        text-align: left;
        margin: 0 5px;
        position: relative;
        top: .1em;

    }
    .detail-body > div:last-child {
        border: 1px solid lightgray;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        padding: 5px;
    }
    .detail-body > div:last-child:empty {
        background:
            repeating-linear-gradient(
                135deg,
                transparent 0,
                transparent 8px,
                lightgray 8px,
                lightgray 16px
            );
        min-height: 36px;
    }
    .arrow {
        margin-left: 1em;
    }
    .btn {
        white-space: nowrap;
    }
</style>
